import { ImageProps } from 'next/image'
import { useState } from 'react'

import { Classified } from '../../rest/types/Classified'
import { AdsMediaGalleryProps } from '../../components/AdsMediaGallery'
import { ImageTransformer } from '../Transformers/ImageTransformer'
import { MediaType } from '../../form/fields/FormFieldUploadMedia'

export function useAdsMediaGalleryProps({
  classified,
  t,
  setIsMediaSliderModalOpen,
  sliderRef,
}: {
  classified?: Classified
  t: any
  setIsMediaSliderModalOpen?: (bool: boolean) => void
  sliderRef?: any
}): AdsMediaGalleryProps | undefined {
  const limitMedia = 6
  const [limit, setLimit] = useState<number>(6)

  const handleShowMorePosts = () => {
    setLimit(limit + limitMedia)
  }

  return classified?.medias?.length
    ? {
        title: t('ads_media_gallery_button_title'),
        mediaList: {
          items: classified?.medias?.length
            ? classified?.medias?.slice(0, limit).map((item, index) => {
                return {
                  ...(item.photo && {
                    preview: ImageTransformer(
                      item?.photo as any,
                      true
                    ) as ImageProps,
                  }),
                  type: item.type as MediaType,
                  onClick: () => {
                    setIsMediaSliderModalOpen?.(true)
                    sliderRef?.current?.slideTo(index)
                  },
                  clickable: true,
                }
              })
            : [],
        },
        ...(classified?.medias &&
          limit <= classified?.medias.length && {
            seeMoreButton: {
              text: t('ads_media_gallery_button_text'),
              onClick: handleShowMorePosts,
            },
          }),
      }
    : undefined
}
